<template>
  <div class="content-wrapper" v-if="!loader">
    <!-- Filter -->
    <invoice-list-filter
      :projects="projectResults"
      :status="status"
      :activeStatus="activeStatus"
      @searchSubmit="searchSubmit"
      @clearFilter="clearFilter" />
    <p class="result-count" v-if="total">{{ totalCount }}</p>
    <div class="p-4 text-center" v-if="noResult && !loader">ไม่มีข้อมูล</div>
    <div v-if="!noResult">
      <div class="result-wrapper">
        <!-- Admin -->
        <div class="header admin other-status" v-if="isRuejaiPartnerAdmin">
          <div class="item">วันที่แจ้ง</div>
          <div class="item">เลขที่ใบแจ้งหนี้</div>
          <div class="item">ผู้ให้บริการ</div>
          <div class="item">โครงการ</div>
          <div class="item">รอบใบแจ้งหนี้</div>
          <div class="item">จำนวนเงินรวม</div>
          <div class="item">สถานะ</div>
        </div>

        <!-- Partner -->
        <div class="header provider other-status" v-else>
          <div class="item">วันที่แจ้ง</div>
          <div class="item">เลขที่ใบแจ้งหนี้</div>
          <div class="item">โครงการ</div>
          <div class="item">รอบใบแจ้งหนี้</div>
          <div class="item">จำนวนเงินรวม</div>
          <div class="item">สถานะ</div>
        </div>

        <!-- Invoice List -->
        <div v-for="invoice in invoiceResults" :key="invoice.id">
          <list-item
          :invoice="invoice"
          :status="status" />
        </div>
      </div>
      <div class="text-center mt-4" v-if="!noResult">
        <el-pagination
          background
          layout="prev, pager, next"
          :pager-count="5"
          :total="total"
          :page-size="10"
          :current-page="getQueryParameters.page"
          @current-change="handlePageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceListFilter from "./InvoiceDashboardInvoiceListFilter";
import InvoiceListItem from "./InvoiceDashboardInvoiceListItem";
import { Pagination } from "element-ui";
import { convertCamelToSnake } from '../../../../lib/util';
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";
import { permissionRole } from "../../lib/mapper";

export default {
  props: ["status", "activeStatus"],
  components: {
    InvoiceListFilter,
    'list-item': InvoiceListItem,
    "el-pagination": Pagination
  },
  data() {
    return {
      roleId: parseInt(localStorage.getItem("supplierRoleId")),
      total: 0,
      projectResults: [],
      invoiceResults: []
    };
  },
  created() {
    this.setupData();
  },
  methods: {
    async setupData() {
      if (this.status === this.activeStatus) {
        await this.setupProjects();
        await this.setupInvoiceList();
      }
    },
    async setupProjects() {
      const parameters = { status: this.status };

      const projects = this.isRuejaiPartnerAdmin
        ? await this.fetchAdminProjects(parameters)
        : await this.fetchProjects(parameters);

      this.projectResults = projects;
    },
    async fetchProjects(parameters) {
      return await baanRueJaiClient.others.supplier.getProjectsByInvoiceStatus(parameters);
    },
    async fetchAdminProjects(parameters) {
      return await baanRueJaiClient.others.supplier.getRuejaiPartnerAdminProjectsByInvoiceStatus(parameters);
    },
    getQueries() {
      const {
        page,
        invoice_no: invoiceNo,
        project_id: projectId,
        created_at_from: createdAtFrom,
        created_at_to: createdAtTo,
        fulfilled_at_from: fulfilledAtFrom,
        fulfilled_at_to: fulfilledAtTo,
        
      } = this.$route.query;

      const query = {
        status: this.status,
        page: parseInt(page) || 1,
        invoiceNo: invoiceNo,
        projectId: projectId,
        createdAtFrom: createdAtFrom,
        createdAtTo: createdAtTo,
        fulfilledAtFrom: fulfilledAtFrom,
        fulfilledAtTo: fulfilledAtTo
      };

      return query;
    },
    getQueryParameters(query) {
      const params = {};

      const {
        status,
        page,
        invoiceNo,
        projectId,
        createdAtFrom,
        createdAtTo,
        fulfilledAtFrom,
        fulfilledAtTo,
      } = query;

      params.status = status || this.status;
      params.page = page || 1;
      if (invoiceNo) params.invoiceNo = invoiceNo;
      if (projectId) params.projectId = projectId;
      if (createdAtFrom) params.createdAtFrom = new Date(createdAtFrom).getTime();
      if (createdAtTo) params.createdAtTo = new Date(createdAtTo).getTime();
      if (fulfilledAtFrom) params.fulfilledAtFrom = new Date(fulfilledAtFrom).getTime();
      if (fulfilledAtTo) params.fulfilledAtTo = new Date(fulfilledAtTo).getTime();

      return params;
    },
    getQueryStrings(query) {
      const params = {};

      const {
        status,
        page,
        invoiceNo,
        projectId,
        createdAtFrom,
        createdAtTo,
        fulfilledAtFrom,
        fulfilledAtTo,
      } = query;

      params.status = status || this.status;
      params.page = page || 1;
      if (invoiceNo) params.invoiceNo = invoiceNo;
      if (projectId) params.projectId = projectId;
      if (createdAtFrom) params.createdAtFrom = this.convertTimeStampToISO(createdAtFrom);
      if (createdAtTo) params.createdAtTo = this.convertTimeStampToISO(createdAtTo);
      if (fulfilledAtFrom) params.fulfilledAtFrom = this.convertTimeStampToISO(fulfilledAtFrom);
      if (fulfilledAtTo) params.fulfilledAtTo = this.convertTimeStampToISO(fulfilledAtTo);

      return params;
    },
    async setupInvoiceList() {
      const queries = this.getQueries();
      const queryStrings = this.getQueryStrings(queries);
      const parameters = convertCamelToSnake(queryStrings);

      const {
        invoices,
        count
      } = this.isRuejaiPartnerAdmin
        ? await this.fetchAdminInvoiceList(parameters)
        : await this.fetchInvoiceList(parameters);

      this.invoiceResults = invoices;
      this.total = count;
    },
    async fetchInvoiceList(parameters) {
      return await baanRueJaiClient.others.supplier.getInvoiceList(parameters);
    },
    async fetchAdminInvoiceList(parameters) {
      return await baanRueJaiClient.others.supplier.getRuejaiPartnerAdminInvoiceList(parameters);
    },
    searchSubmit(query) {
      const queryParameters = this.getQueryParameters(query);
      const queryFormat = convertCamelToSnake(queryParameters);

      this.replaceRoute(queryFormat);
    },
    clearFilter() {
      const query = {};
      query.status = this.status;
      query.page = 1;

      this.replaceRoute(query);
    },
    handlePageChange(page) {
      const query = { ...this.$route.query, page };
      
      this.replaceRoute(query);
    },
    replaceRoute(query) {
      this.$router.replace({
        name: this.$route.name,
        query
      }).catch(() => {});
    },
    convertTimeStampToISO(timestamp) {
      return DateTime.fromMillis(parseInt(timestamp)).toISO();
    }
  },
  computed: {
    loader() {
      return this.$store.state.loader;
    },
    totalCount() {
      const total = this.total ? this.total.toLocaleString() : 0;

      return `ทั้งหมด ${total} รายการ`;
    },
    noResult() {
      return this.invoiceResults.length === 0;
    },
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN;
    }
  },
  watch: {
    async "$route.query"() {
      if (this.status === this.activeStatus) {
        await this.setupProjects();
        await this.setupInvoiceList();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.result-count {
  padding-inline: 24px;
  padding-bottom: 16px;
  font-size: $font-14;
  text-align: right;
}

.result-wrapper {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  overflow-x: auto;

  > .header {
    position: sticky;
    top: 0;
    display: grid;
    width: max-content;
    grid-gap: 16px;
    border-block: 1px solid $color-light-gray-1;
    padding: 12px 24px;
    background-color: $color-background;
  }

  > .header.admin {
    grid-template-columns: 100px 120px 160px 260px 150px 150px 150px;
  }

  > .header.provider {
    grid-template-columns: 150px 150px 320px 150px 150px 150px;
  }

  .item {
    font-size: 14px;
    color: $color-gray;
  }

  .center {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/InvoiceDashboardInvoiceList.vue